export default __webpack_public_path__ + "static/media/Wallet.ff48e883.svg";